export default {
  setAdvertTotalCount (state, { count }) {
    state.advertTotalCount = count
  },

  setAdvertStats (state, { countyId, cityId, district, adverts }) {
    const stats = state.advertisers.find(advertisers =>
      advertisers.countyId === countyId &&
      advertisers.cityId === cityId &&
      advertisers.district === district
    )

    if (stats) {
      state.data = adverts
      return
    }

    state.advertisers.push({
      countyId,
      cityId,
      district,
      data: adverts
    })
  },

  resetAdvertStats (state) {
    state.advertisers = []
  },

  setAdvertOccupations (state, { occupations }) {
    state.advertOccupations = [...state.advertOccupations, ...occupations]
  },

  resetAdvertOccupations (state) {
    state.advertOccupations = []
  },

  setAdvertiserStats (state, data) {
    state.advertiserStats.country = data
  },

  resetAdvertiserStats (state) {
    state.advertiserStats = {
      country: {
        ageGroups: {},
        locEntries: [],
        qualGroups: {}
      },
      counties: []
    }
  },

  setCountyAdvertiserStats (state, { countyId, data, type }) {
    if (type !== 'advertisers') {
      data = { locEntries: data }
    }

    const county = state.advertiserStats.counties.find(county => county.countyId === countyId)
    if (county) {
      county.data = data
      return
    }

    state.advertiserStats.counties.push({
      countyId,
      data
    })
  },

  setAdWatchStats (state, { countyId, cityId, district, adWatches }) {
    state.adwatches.push({
      countyId,
      cityId,
      district,
      data: adWatches
    })
  },

  resetAdWatchStats (state) {
    state.adwatches = []
  },

  setOfferStats (state, { countyId, cityId, district, offers }) {
    state.offers.push({
      countyId,
      cityId,
      district,
      data: offers
    })
  },

  resetOfferStats (state) {
    state.offers = []
  },

  setEmployerSearchOccupations (state, { occupations }) {
    state.employerSearchOccupations = [...state.employerSearchOccupations, ...occupations]
  },

  resetEmployerSearchOccupations (state) {
    state.employerSearchOccupations = []
  },

  setAggregatedAdWatches (state, { adWatches }) {
    state.aggregatedAdWatches = [...state.aggregatedAdWatches, ...adWatches]
  },

  resetAggregatedAdWatches (state) {
    state.aggregatedAdWatches = []
  },

  setStatCounties (state, counties) {
    state.statCounties = counties
  },

  setWeeklyBids (state, { weeklyBids }) {
    state.weeklyBids = weeklyBids
  },

  setWorkLocationStatistics (state, { workLocations }) {
    state.workLocations = [...state.workLocations, ...workLocations]
  },

  resetWorkLocationStatistics (state) {
    state.workLocations = []
  },

  resetStats (state) {
    state.advertOccupations = []
    state.advertTotalCount = 0
    state.advertiserStats = {
      country: {
        ageGroups: {},
        locEntries: [],
        qualGroups: {}
      },
      counties: []
    }
    state.aggregatedAdWatches = []
    state.advertisers = []
    state.adwatches = []
    state.employerSearchOccupations = []
    state.offers = []
    state.topOccupations = []
    state.statAdWatches = []
    state.statCounties = []
    state.weeklyBids = []
    state.workLocations = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/stat/mutations.js